import ticket from './ticket'
import timeline from './timeline'

export default {
  ticket: ticket,
  timeline: timeline
}
